import React from 'react'
import './imageGrid.css'

class ImageGrid extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            imageRows: [],
        }

        this.imageGrid = React.createRef()
        this.handleBoundsUpdate = this.handleBoundsUpdate.bind(this)
        this.handleLayout = this.handleLayout.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
        this.handleBuffers = this.handleBuffers.bind(this)
        
        this.inRAF = false
        this.scrollDirection = 'down'
        this.previousYOffset = 0
        this.latestYOffset = 0
        this.containerHeight = 0
        this.imageRows = []

        this.options = {
            primaryBufferHeight: this.props.options.primaryBufferHeight || 1000,
            secondaryBufferHeight: this.props.options.secondaryBufferHeight || 300,
            gutterSize: this.props.options.gutterSize || 8,
            aspectRatios: {
                sm: this.props.options.aspectRatios && this.props.options.aspectRatios.sm ? this.props.options.aspectRatios.sm : 1,
                md: this.props.options.aspectRatios && this.props.options.aspectRatios.md ? this.props.options.aspectRatios.md : 4,
                lg: this.props.options.aspectRatios && this.props.options.aspectRatios.lg ? this.props.options.aspectRatios.lg : 6,
                xl: this.props.options.aspectRatios && this.props.options.aspectRatios.xl ? this.props.options.aspectRatios.xl : 8 
            },
            scroller: this.props.options.scroller || window
        }

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(e) {
        if (this.props.onClick) {
            this.props.onClick(e)
        }
    }

    handleLayout() {

        const containerWidth = this.imageGrid.current.clientWidth
        const gutterSize = this.options.gutterSize

        const rowAspectRatio = containerWidth <= 640 ?
            this.options.aspectRatios.sm
        : containerWidth <= 1280 ?
            this.options.aspectRatios.md
        : containerWidth <= 1920 ?
            this.options.aspectRatios.lg
        :
            this.options.aspectRatios.xl

        const payload = this.props.images

        const images = []
        payload.map(image => {
            return images.push({
                id: image.id,
                aspectRatio: image.metadata.width / image.metadata.height,
                format: image.mimetype === 'application/pdf' ? 'jpg' : null
            })
        })
        const rows = []

        let aspectRatio = 0
        let row = []
        let translateX = 0
        let translateY = 0
        images.map((image, index) => {

            aspectRatio += parseFloat(image.aspectRatio)
            row.push(image)

            if (aspectRatio >= rowAspectRatio || index + 1 === images.length) {
                aspectRatio = Math.max(aspectRatio, rowAspectRatio)

                const totalDesiredWidthOfImages = containerWidth - gutterSize * (row.length - 1)
                const rowHeight = totalDesiredWidthOfImages / aspectRatio

                row.forEach((img) => {
                    const imageWidth = rowHeight * img.aspectRatio
                    img.style = {
                        width: parseInt(imageWidth, 10),
                        height: parseInt(rowHeight, 10),
                        translateX,
                        translateY
                    }
                    translateX += imageWidth + gutterSize;
                })
                rows.push(row)
                row = []
                aspectRatio = 0
                translateY += parseInt(rowHeight, 10) + gutterSize
                translateX = 0

            }

            return null

        })

        this.imageRows = rows
        this.containerHeight = translateY - gutterSize

        this.handleBuffers()

    }

    handleScroll() {
        const newYOffset = this.options.scroller === window ? window.pageYOffset : this.options.scroller.scrollTop
        this.previousYOffset = this.latestYOffset || newYOffset
        this.latestYOffset = newYOffset
        this.scrollDirection = newYOffset > this.previousYOffset ? 'down' : 'up'

        if (!this.inRAF) {
            this.inRAF = true
            window.requestAnimationFrame(() => {
                this.handleBuffers()
                this.inRAF = false
            })
        }

    }

    handleBuffers() {

        const primaryBufferHeight = this.options.primaryBufferHeight
        const secondaryBufferHeight = this.options.secondaryBufferHeight
        
        const bufferTop = this.scrollDirection === 'up' ? 
            primaryBufferHeight
        :
            secondaryBufferHeight

        const bufferBottom = this.scrollDirection === 'down' ?
            secondaryBufferHeight
        :
            primaryBufferHeight
        
        const containerOffset = this.getOffsetTop(document.getElementById('imageGrid'))

        const scrollerHeight = this.options.scroller === window ? window.innerHeight : this.options.scroller.offsetHeight

        const minTranslateYPlusHeight = this.latestYOffset - containerOffset - bufferTop

        const maxTranslateY = this.latestYOffset - containerOffset + scrollerHeight + bufferBottom

        const visibleRows = []

        this.imageRows.forEach((row) => {
            const image = row[0]
            // console.log('ONE',image.style.translateY + image.style.height, minTranslateYPlusHeight)
            // console.log('TWO',image.style.translateY, maxTranslateY)
            if (image.style.translateY + image.style.height < minTranslateYPlusHeight || image.style.translateY > maxTranslateY) {
                return null
            }
            visibleRows.push(row)
            
        })
        this.setState({ imageRows: visibleRows })
    }

    getOffsetTop(elem) {
        let offsetTop = 0
        do {
            if (!isNaN(elem.offsetTop)) {
                offsetTop += elem.offsetTop
            }
            elem = elem.offsetParent
        } while(elem)
        return offsetTop
    }

    componentDidMount() {
        
        this.handleLayout()
        // window.addEventListener('resize', this.handleBoundsUpdate)
        window.addEventListener('scroll', this.handleScroll)
    }

    handleBoundsUpdate() {
        this.handleLayout()
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.images !==  this.props.images) {
            this.handleLayout()
        }
        // console.log('UPDATE')
        return true
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    render() {

        const { containerHeight } = this
        const { imageRows } = this.state

        return (
            <div ref={this.imageGrid} id='imageGrid' className='imageGrid' style={{ height: containerHeight + 'px' }}>
                {
                    imageRows.map((row, rowIndex) => {
                        return row.map((image, imageIndex) => {

                            return(
                                <ImgLoader key={imageIndex} image={image} onClick={ this.handleClick }/>
                            )
                        })
                    })
                }
            </div>
        )

    }

}

class ImgLoader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            fullSizeLoaded: false
        }
        this.handleLoad = this.handleLoad.bind(this)
    }

    handleLoad(className) {
        if (className === 'fullSize') {
            this.setState({
                fullSizeLoaded: true
            })
            if (this.props.onLoad) {
                this.props.onLoad()
            }
        }
    }

    handleClick(id) {
        if (this.props.onClick) {
            this.props.onClick(id)
        }
    }

    render() {

        const { image } = this.props

        const imgPath = 'https://cdn.tueri.io/'
        // const imgPath = 'http://localhost:3001/'
        const options = image.format ? '&fm=' + image.format : ''

        return(
            <figure key={ image.id } style={{
                width: image.style.width,
                height: image.style.height,
                transform: `translate(${image.style.translateX}px, ${image.style.translateY}px)`
            }} 
            onClick={ () => { this.handleClick(image.id) } }
            className={this.state.fullSizeLoaded ? 'noBackground' : ''}
            >
                <Img className='thumbnail' src={`${imgPath + image.id }/test.jpg?scale.height=${ Math.round(image.style.height / 10) }${ options }`} fadeOut={ this.state.fullSizeLoaded } />
                <Img className='fullSize' src={`${imgPath + image.id }/test.jpg?scale.height=${ Math.round(image.style.height) }${ options }`} onLoad={ this.handleLoad } />
            </figure>
        )
    }
}

class Img extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            fadeOut: false,
            fadeIn: false
        }
        this.handleLoad = this.handleLoad.bind(this)
    }
    
    handleLoad() {
        if (this.props.className !== 'thumbnail') {
            this.setState({
                fadeIn: true
            })
        }
        if (this.props.onLoad) {
            this.props.onLoad(this.props.className)
        }
    }        

    componentDidMount() {
        this.timer = setTimeout(() => {
            this.setState({
                loaded: true
            })
        }, 100)
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    componentDidUpdate(prevProps) {
        // console.log(prevProps, props)
        if (prevProps !== this.props) {
            if (this.props.fadeOut) {
                this.setState({
                    fadeOut: true
                })
            }
        }
    }

    render() {

        const { className, src } = this.props

        const fadeIn = this.state.fadeIn ? 'fadeIn' : ''
        const fadeOut = this.state.fadeOut ? 'fadeOut' : ''
        
        if (this.state.loaded) {
            return  <img className={`${className || ''} ${fadeIn} ${fadeOut}`} src={src} onLoad={ this.handleLoad } alt='' />
        }

        return null

    }
}

export default ImageGrid


// WEBPACK FOOTER //
// ./src/components/ImageGrid/index.js